<ng-container *ngIf="productoresList" [formGroup]="newEditForm">
    <td class="short" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="productoresList" [selectedItem]="newEditForm.get('productor')" [disabled]="disabled" [placeHolder]="false"></app-filterable-list>
    </td>
    <td class="short">
      {{this.nLicencias}}
        <!-- <i class="fas fa-check-circle" *ngIf="licencias"
        title="Productor Con Licencia"></i> -->
    </td>
    <td class="multi-actions">
        <ng-container *ngIf="editable">
            <i class="far fa-save" [ngClass]="{'disabled': (!campanyaHabilitada)}" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" [ngClass]="{'disabled': (!campanyaHabilitada)}" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
            <i class="fas fa-pencil-alt" *ngIf="this.role === 'Administrador' || this.claims.includes('CUL_PROD_Upd')" app-click-stop-propagation
              [ngClass]="{'disabled': (!campanyaHabilitada)}" title="{{'titles.editar' | translate}}" (click)="openLicencias(cultivoProductor)"></i>
            <i class="far fa-trash-alt" *ngIf="this.role === 'Administrador' || this.claims.includes('CUL_PROD_Del')" app-click-stop-propagation
              [ngClass]="{'disabled': (!campanyaHabilitada)}" title="{{'titles.eliminar' | translate}}" (click)="askDelete(cultivoProductor)"></i>
        </ng-container>
    </td>
</ng-container>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
      </header>
      <content>
        <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
      </content>
      <footer>
        <button class="secondary" (click)="closeModal()">{{ 'global.cancelar' | translate }}</button>
        <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
      </footer>
    </div>
</div>
<div class="modal" *ngIf="licenciasModal">
  <div class="modal-content">
      <header>
          <h4>{{'mantenimientoCultivos.tabs.cultivos.cultivoProductor.licencias.titulo' | translate}}</h4>
      </header>
      <app-licencias-productor-cultivo  [cultivoId]="_cultivoId" [productorId]="_productorId" [desProductor]="productor.des"
      (refresh)="toRefresh($event)"></app-licencias-productor-cultivo>
  </div>
</div>
